import type { I18nKey } from 'types/i18n'

import {
    ROUTE_AREA,
    ROUTE_CONFIGURACION_USUARIOS_COMPRAS,
    ROUTE_DEPARTAMENTO,
    ROUTE_EDIFICIO,
    ROUTE_ESTABLECIMIENTO,
    ROUTE_MACRODEPARTAMENTO,
    ROUTE_PERMISOS_ESTRUCTURA_ORGANIZACIONAL,
    ROUTE_PROCESO,
    ROUTE_UNIDAD_NEGOCIO,
} from './nombres'
import { buildBreadcrumb } from '@/@core/utils/router'
import permisos, { RESOURCE_ADMINISTRACION_PG } from '@/auth/permissions/modules/administracionPg'

const { mantenimiento, configuracion } = permisos

const breadcrumbMantenimiento = (option: I18nKey) =>
    buildBreadcrumb('a:administracion.titulo_v2', 'a:global.menu.mantenimiento', option)
const breadcrumbConfiguracion = (option: I18nKey) =>
    buildBreadcrumb('a:administracion.titulo_v2', 'a:global.menu.configuracion', option)

export default [
    //# region Mantenimiento
    {
        path: '/administracion-pg/mantenimiento/unidad-negocio',
        name: ROUTE_UNIDAD_NEGOCIO,
        component: () => import('@/views/pages/administracion-pg/mantenimiento/UnidadNegocio.vue'),
        meta: {
            title: 'i18n:administracion.mantenimiento.unidad_negocio.titulo',
            action: mantenimiento.unidadNegocio,
            resource: RESOURCE_ADMINISTRACION_PG,
            breadcrumb: breadcrumbMantenimiento('administracion.mantenimiento.unidad_negocio.titulo'),
        },
    },
    {
        path: '/administracion-pg/mantenimiento/establecimiento',
        name: ROUTE_ESTABLECIMIENTO,
        component: () => import('@/views/pages/administracion-pg/mantenimiento/Establecimiento.vue'),
        meta: {
            title: 'i18n:administracion.mantenimiento.establecimiento.titulo',
            action: mantenimiento.establecimiento,
            resource: RESOURCE_ADMINISTRACION_PG,
            breadcrumb: breadcrumbMantenimiento('administracion.mantenimiento.establecimiento.titulo'),
        },
    },
    {
        path: '/administracion-pg/mantenimiento/macrodepartamento',
        name: ROUTE_MACRODEPARTAMENTO,
        component: () => import('@/views/pages/administracion-pg/mantenimiento/Macrodepartamento.vue'),
        meta: {
            title: 'i18n:administracion.mantenimiento.macro_departamento.titulo',
            action: mantenimiento.macrodepartamento,
            resource: RESOURCE_ADMINISTRACION_PG,
            breadcrumb: breadcrumbMantenimiento('administracion.mantenimiento.macro_departamento.titulo'),
        },
    },
    {
        path: '/administracion-pg/mantenimiento/departamento',
        name: ROUTE_DEPARTAMENTO,
        component: () => import('@/views/pages/administracion-pg/mantenimiento/Departamento.vue'),
        meta: {
            title: 'i18n:administracion.mantenimiento.departamento.titulo',
            action: mantenimiento.departamento,
            resource: RESOURCE_ADMINISTRACION_PG,
            breadcrumb: breadcrumbMantenimiento('administracion.mantenimiento.departamento.titulo'),
        },
    },
    {
        path: '/administracion-pg/mantenimiento/edificio',
        name: ROUTE_EDIFICIO,
        component: () => import('@/views/pages/administracion-pg/mantenimiento/Edificio.vue'),
        meta: {
            title: 'i18n:global.labels.edificio',
            action: mantenimiento.edificio,
            resource: RESOURCE_ADMINISTRACION_PG,
            breadcrumb: breadcrumbMantenimiento('global.labels.edificio'),
        },
    },
    {
        path: '/administracion-pg/mantenimiento/proceso',
        name: ROUTE_PROCESO,
        component: () => import('@/views/pages/administracion-pg/mantenimiento/Proceso.vue'),
        meta: {
            title: 'i18n:global.labels.proceso',
            action: mantenimiento.proceso,
            resource: RESOURCE_ADMINISTRACION_PG,
            breadcrumb: breadcrumbMantenimiento('global.labels.proceso'),
        },
    },
    {
        path: '/administracion-pg/mantenimiento/area',
        name: ROUTE_AREA,
        component: () => import('@/views/pages/administracion-pg/mantenimiento/Area.vue'),
        meta: {
            title: 'i18n:global.labels.area',
            action: mantenimiento.area,
            resource: RESOURCE_ADMINISTRACION_PG,
            breadcrumb: breadcrumbMantenimiento('global.labels.area'),
        },
    },
    //# endregion

    //# region Configuracion
    {
        path: '/administracion-pg/configuracion/usuarios-compras',
        name: ROUTE_CONFIGURACION_USUARIOS_COMPRAS,
        component: () => import('@/views/pages/administracion-pg/configuracion/UsuariosCompras.vue'),
        meta: {
            title: 'i18n:administracion.configuracion.usuarios_compras',
            action: configuracion.usuariosCompras,
            resource: RESOURCE_ADMINISTRACION_PG,
            breadcrumb: breadcrumbConfiguracion('administracion.configuracion.usuarios_compras'),
        },
    },
    {
        path: '/administracion-pg/configuracion/permisos-estructura-organizacional',
        name: ROUTE_PERMISOS_ESTRUCTURA_ORGANIZACIONAL,
        component: () => import('@/views/pages/administracion-pg/configuracion/PermisosEstructuraOrganizacional.vue'),
        meta: {
            title: 'i18n:administracion-pg.subopciones.permisos_estructura_organizacional',
            action: configuracion.permisosEstructuraOrganizacional,
            resource: RESOURCE_ADMINISTRACION_PG,
            breadcrumb: breadcrumbConfiguracion('administracion-pg.subopciones.permisos_estructura_organizacional'),
        },
    },
]
